import type { Language } from "@app/constants";
import type { AccountType } from "@app/entities";

interface Messages {
	headerAdd: string;
	headerEdit: string;

	errors: {
		fieldsRequired: string;
		generic: string;
	};

	tooltip: {
		bankName: string;
		branchCode: string;
		accountType: string;
		accountNumber: string;
	};

	accountHolder: string;
	bankName: string;
	branchCode: string;
	accountType: string;
	accountNumber: string;
	submit: string;
	accessibleBy: string;

	accountTypes: {
		[key in AccountType]: string;
	};
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		headerAdd: "Add Bank Account",
		headerEdit: "Edit Bank Account",

		errors: {
			fieldsRequired: "Please complete the required fields highlighted in red",
			generic: "There are errors in your submission. Please see above.",
		},

		tooltip: {
			bankName: "Please enter your bank name",
			branchCode: "Please enter your branch code",
			accountType: "Please choose your account type",
			accountNumber: "Please enter your account number",
		},

		accountTypes: {
			bond: "Bond Account",
			cheque: "Current/Cheque Account",
			credit: "Credit Card Account",
			savings: "Savings Account",
			subscription: "Subscription Account",
			transmission: "Transmission Account",
		},

		accountHolder: "Account Holder *",
		bankName: "Bank *",
		branchCode: "Branch Code *",
		accountType: "Account Type *",
		accountNumber: "Account Number *",
		accessibleBy: "Allow spouse to withdraw to this account?",

		submit: "SUBMIT",
	},
};

export default messages;
